/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetListResponse {
    getFixupPrototypeFunction() { return BudgetListResponse.fixupPrototype; }

    static newInstance(model: Partial<BudgetListResponse>): BudgetListResponse {
        let obj = Object.assign(new BudgetListResponse(), model);
        BudgetListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetListResponse>): BudgetListResponse {
        if (!model) return null;
        return BudgetListResponse.newInstance(<BudgetListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetListResponse) {
        if (!obj) return;

        models.BudgetListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetListResponse): boolean {
        Object.setPrototypeOf(obj, BudgetListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_budgets_count === undefined) {
            this.total_budgets_count = 0;
        }
        if (this.budgets_list) {
            for (let val of this.budgets_list) {
                models.ListBudgetsModel.fixupPrototype(val);
            }
        }
    }

    /**
     * Total Budgets count
     */
    total_budgets_count: number;

    /**
     * Details of violation
     */
    budgets_list: Array<models.ListBudgetsModel>;

}
